import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionAddToListEditorComponent from './ActionAddToListEditorComponent';

class ActionAddToListEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionAddToListEditorComponent />} type='add-to-list' icon='add_notes' />;
  }
}

export default ActionAddToListEditorContainer;
